import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setOrdersToRetrieveFilters } from '../../../orderSlice';

export default function useObserveTopCard({
  filters,
  topInView,
  loadMoreTopRef,
  setIsLoadingMore,
  totalPages,
}) {
  const dispatch = useDispatch();
  // If last card is inside the viewPort, calls hook above to fetch more orders
  useEffect(() => {
    const { page, ...rest } = filters;

    // Check if top card is in viewport and the loadMore ref is true
    if (topInView && loadMoreTopRef.current) {
      loadMoreTopRef.current = false;

      setIsLoadingMore(true);
      dispatch(
        setOrdersToRetrieveFilters({
          page: filters.page - 1,
          ...rest,
        })
      );
    }
  }, [
    topInView,
    filters,
    totalPages,
    dispatch,
    loadMoreTopRef,
    setIsLoadingMore,
  ]);
}
